import { React, useState, useEffect } from "react"; 
import { Grid, Tabs, Tab, Box } from "@mui/material";
import PropTypes from "prop-types";
import JobDetailsTabFun from "./JobDetailsTab";
import QuoteCalculationPage from "./QuoteCalculationTab";
import "./styles.css";
import { useParams } from "react-router-dom";
import HomeHeader from "../../components/HomeHeader";
import { useFetchViewJobDetailsbyIdQuery } from "../../reducer/viewJobReducer";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function ViewJobDetailsFn() {
  const [value, setValue] = useState(0);
  const { jobId } = useParams(); // Get jobId from URL params
  const [jobDetailsData, setJobDetailsData] = useState(null);

  // Fetch job details using the jobId from the URL
  const { data: jobDetails } = useFetchViewJobDetailsbyIdQuery(jobId, {
    skip: !jobId,
  });

  useEffect(() => {
    setJobDetailsData(jobDetails);
  }, [jobDetails]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // Debugging logs
  useEffect(() => {
    console.log(jobDetailsData); // Check the fetched data
  }, [jobDetailsData]);

  useEffect(() => {
    if (jobDetails) {
      // Set initial tab value if needed
      let tabValue = jobDetails.tabVal || 0;
      setValue(tabValue);
    }
  }, [jobDetails]);

  return (
    <Grid sx={{ backgroundColor: "#FFF" }}>
      <Grid padding="5% 5% 2% 5%" display="flex" alignItems="center" style={{ backgroundColor: '#fff' }}>
        <HomeHeader header={<>Job no #{jobId}</>} bgColor="#fff" />
      </Grid>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider", margin: "0% 6%" }}>
          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" variant="fullWidth">
            <Tab label="Job Details" {...a11yProps(0)} />
            <Tab label="Quote Calculation" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <JobDetailsTabFun stateValue={jobDetailsData} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <QuoteCalculationPage
            stateValue={jobDetailsData}
            existingQuotesValue={jobDetailsData?.quotes}
            paymentDetails={jobDetailsData?.paymenthstry}
          />
        </TabPanel>
      </Box>
    </Grid>
  );
}

export default ViewJobDetailsFn;
